angular.module('admin')

.controller('AgentCtrl', ['$scope', '$state', 'AgentService', 'PageNotificationService',
function($scope, $state, AgentService, PageNotificationService){

  $scope.agentId =  $state.params.id;

  $scope.getAgent = function(){
    return AgentService.getOne($scope.agentId, {filter: {include: ['office']}})
      .then((agent) => {
        $scope.agent = agent;
      })
      .catch((err) => {
        PageNotificationService.error('There was an error loading agent profile. ' + err);
      });
  };

  $scope.getAgent();

}]);
